// PASSPORT(0)抽奖机会，COUPON(4)券，RED_PACKET(2)红包，VIRTUAL_CURRENCY(3)奖励金
// CURRENCY(5)现金，ENTITY(1)实物，MEMBER(7)会员，OIL_COUPON(6)加油卡，NULL(-1)无奖励
export const AWARD_TYPE_ID_MAP = {
  0: 'PASSPORT',
  1: 'ENTITY',
  2: 'RED_PACKET',
  3: 'VIRTUAL_CURRENCY',
  4: 'COUPON',
  5: 'CURRENCY',
  6: 'OIL_COUPON',
  7: 'MEMBER',
  '-1': 'NULL'
};
